/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TariffSummaryResultsIndividualText { 
    show?: boolean;
    individualText_perMonth?: string;
    individualText_workPrice_infotext?: string;
    individualText_basePrice?: string;
    individualText_basePrice_infotext?: string;
    individualText_annualPrice?: string;
    individualText_monthlyPrice?: string;
}

